/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

// import Types from '../../../common/modules/types';

const isNotZoom = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'ZOOM',
]);

export default [
  ...[
    getFilterWithCol(['FieldText', {
      label: null,
      name: 'zoom_value',
      prefix: 'Zoom:',
      align: 'right',
    }], 24),
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotZoom, ...(fieldConfig.preSkip || [])],
    },
  ])),
];
